import { __awaiter, __generator } from "tslib";
import * as React from 'react';
import DropDownMenu from '../client/src/modules/chat/components/DropDownMenu/DropDownMenu';
import ModalComp from '../client/src/modules/chat/components/Modal/Modal';
import { domainAction } from '../client/src/modules/domain/domain-redux';
import { BytesizeIcon } from '../client/src/modules/_core/components/BytesizeIcon';
import { api } from '../client/src/modules/_core/utils/api-helpers';
import { getSessionThreadId } from '../client/src/modules/_core/utils/app-storage';
import EmailForm from './EmailForm';
import StaffinoWidget from './sazka/components/StaffinoWidget';
import { headerOnCloseHandler } from './sazka/externals-fns/header-close-handler';
var DropdownWithModal = function (props) {
    var _a;
    var cmp = props.cmp, openStaffino = props.openStaffino, content = props.content, handleCancel = props.handleCancel;
    var email = (_a = cmp.props.initialData) === null || _a === void 0 ? void 0 : _a.Username;
    var GDPRUrl = 'https://www.sazka.cz/zpracovani-osobnich-udaju/ochrana-osobnich-udaju';
    var _b = React.useState(false), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var _c = React.useState(), modalContent = _c[0], setModalContent = _c[1];
    var _d = React.useState(true), showModalHeader = _d[0], setShowModalHeader = _d[1];
    var _e = React.useState(false), isSoundEnabled = _e[0], setIsSoundEnabled = _e[1];
    var _f = React.useState(''), errorText = _f[0], setErrorText = _f[1];
    React.useEffect(function () {
        // external function is openining staffino
        if (openStaffino !== isModalOpen) {
            setIsModalOpen(openStaffino);
            setModalContent('staffino');
        }
    }, [openStaffino]);
    var showEmail = function () {
        setModalContent('email');
        setIsModalOpen(true);
    };
    React.useEffect(function () {
        var useMsgSound = window.localStorage.getItem('useMsgSound');
        var isSoundEnabled = useMsgSound === 'true';
        setIsSoundEnabled(isSoundEnabled);
        domainAction.setUseMsgSound(isSoundEnabled);
    }, []);
    var getModalContent = function () {
        var content;
        switch (modalContent) {
            case 'alert':
                showModalHeader && setShowModalHeader(false);
                content = (React.createElement("div", { style: { textAlign: 'center' } },
                    React.createElement("svg", { width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: { marginBottom: '16px', marginTop: '12px' } },
                        React.createElement("circle", { cx: "20", cy: "20", r: "20", fill: "#00A228" }),
                        React.createElement("path", { d: "M28 16L18.5753 25L14 20.4247", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })),
                    React.createElement("h4", { style: { marginBottom: '24px', fontSize: '20px' } }, "Chat byl odesl\u00E1n")));
                break;
            case 'email':
                !showModalHeader && setShowModalHeader(true);
                content = (React.createElement(React.Fragment, null,
                    React.createElement(EmailForm, { submitLabel: "Odeslat", cancelLabel: "Zru\u0161it", inputPlaceholder: "Va\u0161e emailov\u00E1 adresa", email: email, handleSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
                            var threadId, error_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        threadId = getSessionThreadId();
                                        return [4 /*yield*/, api().sendMail(threadId, values.email)];
                                    case 1:
                                        _a.sent();
                                        setModalContent('alert');
                                        setTimeout(function () {
                                            setIsModalOpen(handleCancel());
                                        }, 1000);
                                        return [3 /*break*/, 3];
                                    case 2:
                                        error_1 = _a.sent();
                                        setErrorText('Chat se nepodařilo odeslat. Zkuste to prosím znovu.');
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); }, handleCancel: function () { return setIsModalOpen(handleCancel()); } }),
                    errorText && (React.createElement("p", { style: { color: 'red', fontSize: '14px' } }, errorText))));
                break;
            case 'staffino':
                showModalHeader && setShowModalHeader(false);
                content = (React.createElement(StaffinoWidget, { handleSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
                        var threadId;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    threadId = getSessionThreadId();
                                    return [4 /*yield*/, api().sendStaffino(threadId, values)];
                                case 1:
                                    _a.sent();
                                    headerOnCloseHandler(cmp, function () { }, true);
                                    handleCancel();
                                    return [2 /*return*/];
                            }
                        });
                    }); }, handleCancel: function () {
                        headerOnCloseHandler(cmp, function () { }, true);
                        handleCancel();
                    } }));
                break;
            default:
                break;
        }
        return content;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DropDownMenu, { items: [
                {
                    id: 'sound',
                    onClick: function () {
                        setIsSoundEnabled(!isSoundEnabled);
                        window.localStorage.setItem('useMsgSound', String(!isSoundEnabled));
                        cmp.props.dispatch(domainAction.setUseMsgSound(!isSoundEnabled));
                    },
                    content: "".concat(isSoundEnabled ? 'Vypnout' : 'Zapnout', " zvuk chatu"),
                },
                {
                    id: 'mail',
                    onClick: showEmail,
                    content: (React.createElement(React.Fragment, null,
                        React.createElement("span", null, "Odeslat chat na email"),
                        React.createElement(BytesizeIcon, { name: "arrow-right", size: "smallest", thickness: "medium" }))),
                },
                {
                    id: 'GDPR',
                    onClick: function () {
                        window.open(GDPRUrl, '_blank');
                    },
                    content: (React.createElement(React.Fragment, null,
                        React.createElement("a", { target: "_blank", href: GDPRUrl }, "GDPR"),
                        React.createElement(BytesizeIcon, { name: "arrow-right", size: "smallest", thickness: "medium" }))),
                },
            ], size: "sm" },
            React.createElement("span", { className: "menu-icon" })),
        React.createElement(ModalComp, { header: showModalHeader && 'Odeslat chat na e-mail', isModalOpen: isModalOpen, content: getModalContent(), handleClose: function () { return setIsModalOpen(handleCancel()); }, hideFooter: true })));
};
export default DropdownWithModal;
